import React from 'react';
import { shape, string, array } from 'prop-types';
import { Link, graphql } from 'gatsby';

import TemplateSimple from '../components/templateSimple';
import { handleData } from '../lib/dataHelper';

const MentionsLegales = ({ data }) => {
  const dataToUse = handleData(data) || {};
  const { title, postalAddress, legalStatus, registeredCapital, registrationNumber, vatNumber } = dataToUse;
  const { site = {} } = data;
  const { builtBy = '' } = site.siteMetadata;

  return (
    <TemplateSimple pageTitle="Mentions légales" data={dataToUse}>
      <h2>Dénomination et siège social</h2>
      <p>
        {title}, {postalAddress}
        <br />
        Forme juridique : {legalStatus}
        <br />
        Capital social : {registeredCapital}
        <br />
        Numéro d'inscription au registre du commerce et des sociétés (RCS) ou numéro d'immatriculation au répertoire des
        métiers (RM) : {registrationNumber}
        <br />
        Numéro de TVA intracommunautaire : <span itemProp="vatID">{vatNumber}</span>
      </p>
      <h2>Réalisation</h2>
      <p>{builtBy}</p>
      <h2>Directeur de la publication</h2>
      <p>Franck PERGE</p>
      <h2>Dénomination et adresse de l'hébergeur</h2>
      <p>
        Amazon Web Services, Inc.
        <br />
        410 Terry Ave North
        <br />
        Seattle, WA 98109-5210, US
      </p>
      <h2>Protection des données personnelles</h2>
      <p>
        Vous disposez d'un droit d'accès, de modification et de suppression des données qui vous concernent (Loi du 6
        janvier 1978 Informatique et liberté).
      </p>
      <h2>Conditions d'utilisation</h2>
      <p>
        L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété
        intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et
        les représentations iconographiques et photographiques. Le contenu est, sauf mention contraire, la propriété de
        (Raison Sociale Installateur) et de PERGE. La reproduction de tout ou partie de ce site, sous quelques formes
        que ce soit est interdite.
      </p>
    </TemplateSimple>
  );
};

export const query = graphql`
  query MentionsLegalesQuery($partenaireId: Int!) {
    site {
      siteMetadata {
        builtBy
      }
    }
    staticMap {
      ...Map
    }
    strapiPartenaires(strapiId: { eq: $partenaireId }) {
      legalStatus: forme_juridique
      registeredCapital: capital_social
      registrationNumber: immatriculation_rcs_rm
      vatNumber: tva_intracommunautaire
      ...Contact
      ...Logo
      ...Header
      ...Footer
    }
  }
`;

export default MentionsLegales;
